var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    { attrs: { "default-active": "1-1" } },
    [
      _c(
        "el-submenu",
        { attrs: { index: "1" } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { staticClass: "el-icon-location" }),
            _vm._v(" "),
            _c("span", [_vm._v("Οι Συνομιλίες μου")])
          ]),
          _vm._v(" "),
          _vm._l(_vm.privateChats, function(chat) {
            return _c(
              "el-menu-item",
              {
                key: chat.id,
                attrs: { index: "1-1" },
                on: {
                  click: function($event) {
                    _vm.openChat(chat.id, chat.label)
                  }
                }
              },
              [
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "right",
                      title: "Συμμετέχοντες",
                      width: "300",
                      trigger: "hover",
                      content: _vm.currentChatMembers
                    },
                    on: {
                      show: function($event) {
                        _vm.chatMembers(chat.id)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "reference" }, slot: "reference" },
                      [
                        _vm._v(_vm._s(chat.label) + "\n          "),
                        _vm.calcNewMesPerRoom(chat.label) != 0
                          ? _c("el-badge", {
                              staticClass: "item",
                              attrs: {
                                type: "primary",
                                value: _vm.calcNewMesPerRoom(chat.label)
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-submenu",
        { attrs: { index: "2" } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { staticClass: "el-icon-location" }),
            _vm._v(" "),
            _c("span", [_vm._v("Οι Ανοιχτές Συνομιλίες μου")])
          ]),
          _vm._v(" "),
          _vm._l(_vm.myPubliChats, function(chat) {
            return _c(
              "el-menu-item",
              {
                key: chat.id,
                attrs: { index: "2-1" },
                on: {
                  click: function($event) {
                    _vm.openChat(chat.id, chat.label)
                  }
                }
              },
              [
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "right",
                      title: "Συμμετέχοντες",
                      width: "300",
                      trigger: "hover",
                      content: _vm.currentChatMembers
                    },
                    on: {
                      show: function($event) {
                        _vm.chatMembers(chat.id)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "reference" }, slot: "reference" },
                      [
                        _vm._v(_vm._s(chat.label) + "\n          "),
                        _vm.calcNewMesPerRoom(chat.label) != 0
                          ? _c("el-badge", {
                              staticClass: "item",
                              attrs: {
                                type: "primary",
                                value: _vm.calcNewMesPerRoom(chat.label)
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      ["SpecialProponent", "PreChecker"].includes(_vm.activeRole)
        ? _c(
            "el-submenu",
            { attrs: { index: "3" } },
            [
              _c("template", { slot: "title" }, [
                _c("i", { staticClass: "el-icon-location" }),
                _vm._v(" "),
                _c("span", [_vm._v("Συνομιλίες με πολίτες")])
              ]),
              _vm._v(" "),
              _vm._l(_vm.myExternalChats, function(chat) {
                return _c(
                  "el-menu-item",
                  {
                    key: chat.id,
                    attrs: { index: "1-1" },
                    on: {
                      click: function($event) {
                        _vm.openChat(chat.id, chat.label, "external")
                      }
                    }
                  },
                  [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "right",
                          title: "Συμμετέχοντες",
                          width: "300",
                          trigger: "hover"
                        }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "reference" }, slot: "reference" },
                          [
                            _vm._v(_vm._s(chat.label) + "\n          "),
                            _vm.calcNewMesPerExternal(chat.label) != 0
                              ? _c("el-badge", {
                                  staticClass: "item",
                                  attrs: {
                                    type: "primary",
                                    value: _vm.calcNewMesPerExternal(chat.label)
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-menu-item",
        { attrs: { index: "3" }, on: { click: _vm.manageRooms } },
        [
          _c("i", { staticClass: "el-icon-document" }),
          _vm._v(" "),
          _c("span", [_vm._v("Διαχείριση Συνομιλιών")])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-748a54ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748a54ad","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/chat/ChatRooms.vue
// module id = null
// module chunks = 